/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDown, TextInput } from "components/InputsMex/inputs";
import { IndexColumn } from "components/Table/Columns";
import useQueryParams from "hooks/useQueryParams";
import _ from "lodash";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import * as uuid from "uuid";
import SwitchFormContratanteAsegurado from "./SwitchFormContratanteAsegurado";

const FormAseguradoHerederos = ({
  catalogo,
  buscarMunicipios,
  buscarColonias,
  setColonias,
  setMunicipios,
  municipios,
  colonias,
  formulario = "asegurados",
}) => {
  const methods = useFormContext();
  const { parametros } = methods;
  const { parentesco, codProducto } = useQueryParams();
  const [porcentajeActual, setPorcentajeActual] = useState(0);
  const [porcentajeDisponible, setPorcentajeDisponible] = useState(0);
  const [beneficiarios, setBeneficiarios] = useState([]);

  const [loadingMunicipios, setLoadingMunicipios] = useState(false);
  const [loadingColonias, setLoadingColonias] = useState(false);

  const { validaciones } = catalogo;

  const beneficiariosWatcher = methods.watch("beneficiarios");

  const secciones = useMemo(
    () =>
      catalogo?.agrupaciones
        ?.filter((seccion) => {
          if (seccion.hasOwnProperty("formulario") && seccion.formulario !== formulario) {
            return false;
          }
          return true;
        })
        ?.map((seccion) => {
          seccion.campos = validaciones.filter((campo) => campo.grupo === seccion.codigo);
          return seccion;
        }),
    []
  );

  useEffect(() => {
    const beneficiariosTemp = beneficiariosWatcher;

    if (beneficiariosTemp && "length" in beneficiariosTemp) {
      setBeneficiarios(beneficiariosTemp);

      if (beneficiariosTemp.length > 0) {
        const porcentajeActualTemp = getPorcentajeActual(beneficiariosTemp);

        setPorcentajeActual(porcentajeActualTemp);
        setPorcentajeDisponible(parametros.porcentaje - porcentajeActualTemp);
      } else {
        setPorcentajeDisponible(parametros.porcentaje);
        setPorcentajeActual(0);
      }
    } else {
      setPorcentajeDisponible(parametros.porcentaje);
      setPorcentajeActual(0);
    }
  });

  const getPorcentajeActual = (beneficiariosArg) => {
    return beneficiariosArg
      .map((ben) => Number(ben.porcentaje))
      .reduce((a, b) => Number(a) + Number(b));
  };

  useEffect(() => {
    methods.register("beneficiarios", {
      validate: (value) => {
        if (
          !value ||
          value.length < parametros.minimoBeneficiarios ||
          value.length > parametros.maximoBeneficiarios
        ) {
          return `Debe ingresar mínimo ${parametros.minimoBeneficiarios} y un máximo de ${parametros.maximoBeneficiarios} beneficiarios`;
        }
        const dataBeneficiarios = methods.watch("beneficiarios");
        if (getPorcentajeActual(dataBeneficiarios) < parametros.porcentaje) {
          return `Debe de completar el ${parametros.porcentaje}% de porcentaje entre los beneficiarios ingresados`;
        }

        return true;
      },
    });
  }, []);

  const onChangeEstado = async (estado) => {
    methods.setValue("municipio", null);
    methods.setValue("colonia", null);
    methods.setValue("codigoPostal", "");
    setMunicipios([]);
    setColonias([]);
    if (estado) {
      setLoadingMunicipios(true);
      setLoadingColonias(true);
      buscarMunicipios(estado.codPais, estado.codDpto).then((res) => {
        setLoadingMunicipios(false);
        setLoadingColonias(false);
      });
    }
  };

  const onChangeMunicipio = async (municipio) => {
    methods.setValue("colonia", null);
    methods.setValue("codigoPostal", "");
    setColonias([]);
    if (municipio) {
      setLoadingColonias(true);
      buscarColonias(municipio).then((res) => {
        setLoadingColonias(false);
      });
    }
  };

  const onChangeColonia = (colonia) => {
    methods.setValue("codigoPostal", colonia?.codPostal);
    methods.clearErrors("codigoPostal");
  };

  const header = (
    <div className='mt-2 container-fluid justify-content-around'>
      <div className='row justify-content-center'>
        <div className='col align-self-center'>
          <ModalFormBeneficiario
            catalogo={catalogo}
            beneficiarios={beneficiarios}
            porcentajeActual={porcentajeActual}
            porcentajeDisponible={porcentajeDisponible}
          />
        </div>
        <div className='col align-self-center'>
          <h6>
            Beneficiarios: {beneficiarios.length} de {parametros.maximoBeneficiarios}
          </h6>
        </div>
        <div className='col align-self-center'>
          <h6 className='align-self-center'>Porcentaje: {parametros.porcentaje}%</h6>
        </div>
      </div>
    </div>
  );

  const onCheckSeccion = (seccion) => (evt) => {
    try {
      const isChecked = evt?.target?.checked;

      seccion.copyFields.forEach((field) => {
        try {
          let value = _.get(catalogo?.sources, field?.path, field?.default);
          if (isChecked && seccion?.codigo === "ubicacion") {
            switch (field?.name) {
              case "estado":
                onChangeEstado(value);
                break;

              case "municipio":
                onChangeMunicipio(value);
                break;

              case "colonia":
                onChangeColonia(value);

                break;

              default:
                break;
            }
          }
          methods.setValue(field?.name, isChecked ? value : field?.defaultOnUCheck);
        } catch (error) {}
      });
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <div className='row justify-content-center'>
        <div className='col-11 col-sm-12 col-md-10 card-login-mex'>
          <h2
            className='font-mex mt-4 mb-3 text-mex text-center'
            style={{ fontSize: "26px" }}>
            Asegurado
          </h2>
          <div className='row justify-content-center justify-content-lg-between'>
            <div className='col-md-6 col-lg-5 mb-5'>
              <SimpleContainer label='Tipo de persona' name='tipoPersona'>
                <DropDown
                  rules={{
                    required: "Obligatorio",
                  }}
                  name='tipoPersona'
                  options={catalogo?.tipoPersona
                    ?.filter((e) => e.value === "F")
                    ?.map((e) => ({
                      label: e.label,
                      value: e,
                    }))}
                />
              </SimpleContainer>
            </div>
            <div className='col-12'>
              {parentesco === "hijo" && (
                <h6 className='ml-4'>
                  * Solo se pueden asegurar hijos dependientes económicos
                </h6>
              )}
            </div>

            {methods.watch("tipoPersona")?.value &&
              secciones.map(
                (seccion, index) =>
                  !seccion.disabled && (
                    <div key={index} className='row w-100 justify-content-center'>
                      <div className='col-12 ml-5'>
                        <div className='d-flex flex-row'>
                          <img
                            className='img-fluid'
                            src={seccion.urlIcono}
                            alt={seccion.label}
                            style={{ width: "40px" }}
                          />
                          <h2 className='text-primary my-auto'>{seccion.label}</h2>
                          {seccion?.checkboxActivo && (
                            <React.Fragment>
                              <div className='align-self-end ml-1 mt-3'>
                                <input
                                  type='checkbox'
                                  id={seccion?.label}
                                  className='chek-terminos'
                                  onChange={onCheckSeccion(seccion)}
                                />
                                <label
                                  htmlFor={seccion?.label}
                                  className='term-condiciones'>
                                  Usar información del contratante
                                </label>
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      </div>

                      <div className='col-12'>
                        <div className='row justify-content-center'>
                          <div className='col-md-11 col-lg-10'>
                            <div className='row justify-content-center justify-content-lg-between w-100'>
                              <SwitchFormContratanteAsegurado
                                formulario={formulario}
                                producto={codProducto}
                                campos={seccion.campos}
                                catalogo={catalogo}
                                onChanges={{
                                  onChangeEstado,
                                  onChangeMunicipio,
                                  onChangeColonia,
                                }}
                                loadings={{
                                  loadingMunicipios,
                                  loadingColonias,
                                }}
                                sources={{ municipios, colonias }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
              )}

            <div className='col-lg-12 mb-5 ml-4'>
              <h6 className='font-mex '>Agregar beneficiarios</h6>
              <p className='error-msg-input' style={{ fontSize: "19px" }}>
                {methods.errors?.beneficiarios?.message}
              </p>

              <DataTable
                value={beneficiarios}
                editMode='row'
                dataKey='id'
                className='p-datatable-gridlines'
                header={header}
                rowHover
                style={{ width: "calc(100% - 3rem)" }}
                autoLayout>
                {IndexColumn({
                  header: "Beneficiario",
                  headerClassName: "bg-cyan50 text-coreBlue",
                })}
                <Column
                  field='nombres'
                  header='Nombres'
                  headerClassName='bg-cyan50 text-coreBlue'
                  body={(rowData) => {
                    return `${rowData.nombres} ${rowData.apellidoPaterno} ${rowData.apellidoMaterno}`;
                  }}
                />
                <Column
                  field='rfc'
                  header='RFC'
                  headerClassName='bg-cyan50 text-coreBlue'
                />
                <Column
                  field='parentescoLabel'
                  header='Parentesco asegurado / beneficiario'
                  headerClassName='bg-cyan50 text-coreBlue'
                />
                <Column
                  field='porcentaje'
                  header='Porcentaje'
                  headerClassName='bg-cyan50 text-coreBlue'
                />

                <Column
                  header='Opciones'
                  style={{ width: "220px", padding: "0 0.5rem" }}
                  headerClassName='bg-cyan50 text-coreBlue'
                  body={(rowData) => {
                    const onClickEliminar = () => {
                      const index = beneficiarios.indexOf(rowData);
                      beneficiarios.splice(index, 1);
                      methods.setValue("beneficiarios", beneficiarios);
                    };
                    return (
                      <div className='d-flex flex-row flex-wrap justify-content-between'>
                        <ModalFormBeneficiario
                          key={rowData.uuid}
                          catalogo={catalogo}
                          beneficiarios={beneficiarios}
                          porcentajeActual={porcentajeActual}
                          porcentajeDisponible={porcentajeDisponible}
                          initialData={rowData}
                          action='edit'
                        />
                        <button
                          className='btn btn-primary btn-sm'
                          onClick={onClickEliminar}>
                          Eliminar
                        </button>
                      </div>
                    );
                  }}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormAseguradoHerederos;

const ModalFormBeneficiario = ({
  catalogo,
  beneficiarios = [],
  porcentajeActual,
  porcentajeDisponible,
  initialData,
  action = "add",
}) => {
  const { setValue, parametros, clearErrors } = useFormContext();
  const methods = useForm({ mode: "onChange" });
  const [modal, setModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const { porcentaje, maximoBeneficiarios } = parametros;

  const toggle = () => setModal(!modal);

  useEffect(() => {
    if (action === "edit") {
      methods.reset(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    if (action === "add") {
      setIsDisabled(
        beneficiarios.length === maximoBeneficiarios || porcentajeActual === porcentaje
      );
    }
  });

  const onClickGuardar = (data) => {
    data.parentescoLabel =
      catalogo?.objParentezcos?.catalogoParentezcosBeneficiarios.find(
        (e) => e.value === data.parentesco
      )?.label;

    if (action === "add") {
      data.uuid = uuid.v4();
      beneficiarios.push(data);
    } else {
      const beneficiario = beneficiarios.find((e) => e.uuid === initialData.uuid);
      const index = beneficiarios.indexOf(beneficiario);
      beneficiarios[index] = { ...beneficiarios[index], ...data };
    }
    setValue("beneficiarios", beneficiarios);
    setModal(false);
    clearErrors("beneficiarios");
  };

  const getPorcentajeDisponibleForm = () => {
    if (action === "edit") {
      return porcentajeDisponible + Number(initialData.porcentaje);
    }
    return porcentajeDisponible;
  };

  return (
    <div>
      <button className='btn btn-primary btn-sm' onClick={toggle} disabled={isDisabled}>
        {action === "add" && "Agregar Beneficiario"}
        {action === "edit" && "Editar"}
      </button>

      {action === "add" && (
        <React.Fragment>
          {beneficiarios.length === maximoBeneficiarios && (
            <p style={{ fontSize: "20px" }}>Ha ingresado el máximo de beneficiarios</p>
          )}

          {porcentajeActual === porcentaje && (
            <p style={{ fontSiz: "20px" }}>Ha ingresado el máximo de porcentaje</p>
          )}
        </React.Fragment>
      )}

      <FormProvider {...methods}>
        <form>
          <Modal centered show={modal} onHide={toggle} size='lg'>
            <Modal.Header closeButton>
              <h2
                className='font-mex mt-4 mb-3 text-mex text-center'
                style={{ fontSize: "26px" }}>
                {action === "add" && "Agregar beneficiario"}
                {action === "edit" && "Editar beneficiario"}
              </h2>
            </Modal.Header>
            <Modal.Body style={{ minHeight: "10rem" }}>
              <div className='container-fluid'>
                <div className='row justify-content-center'>
                  <div className='form-group col-7 '>
                    <SimpleContainer label='Nombres:' name='nombres'>
                      <TextInput
                        inputProps={{ name: "nombres" }}
                        rules={{
                          required: "Obligatorio",
                          maxLength: {
                            value: 25,
                            message: "Debe ingresar máximo 25 caracteres",
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                  <div className='form-group col-7 '>
                    <SimpleContainer label='Apellido paterno:' name='apellidoPaterno'>
                      <TextInput
                        inputProps={{ name: "apellidoPaterno" }}
                        rules={{
                          required: "Obligatorio",
                          maxLength: {
                            value: 20,
                            message: "Debe ingresar máximo 20 caracteres",
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                  <div className='form-group col-7 '>
                    <SimpleContainer label='Apellido materno:' name='apellidoMaterno'>
                      <TextInput
                        inputProps={{ name: "apellidoMaterno" }}
                        rules={{
                          maxLength: {
                            value: 20,
                            message: "Debe ingresar máximo 20 caracteres",
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                  <div className='form-group col-7 '>
                    <SimpleContainer
                      label='RFC:'
                      name='rfc'
                      helpText='Este campo es opcional'>
                      <TextInput
                        inputProps={{ name: "rfc" }}
                        rules={{
                          pattern: {
                            value: /^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/,
                            message:
                              "RFC incorrecto, el formato esperado es: AAAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos",
                          },
                          maxLength: {
                            value: 13,
                            message: "Solo puede ingresar un máximo de 13 caracteres",
                          },

                          validate: (value) => {
                            if (value && value.trim() !== "") {
                              const obj = beneficiarios.find((e) => {
                                if (action === "edit") {
                                  return e.uuid !== initialData.uuid && e.rfc === value;
                                }
                                return e.rfc === value;
                              });

                              if (obj) {
                                return "No se puede repetir en mas de un beneficiario";
                              }
                            }

                            return true;
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                  <div className='form-group col-7 '>
                    <SimpleContainer label='Parentesco:' name='parentesco'>
                      <DropDown
                        name='parentesco'
                        options={
                          catalogo?.objParentezcos?.catalogoParentezcosBeneficiarios
                        }
                        rules={{ required: "Obligatorio" }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                  <div className='form-group col-7 '>
                    <SimpleContainer
                      label='Porcentaje:'
                      name='porcentaje'
                      helpText={`Porcentaje disponible ${getPorcentajeDisponibleForm()}`}>
                      <TextInput
                        inputProps={{ name: "porcentaje", isNumberInt: true }}
                        hideArrows
                        rules={{
                          required: "Obligatorio",
                          max: {
                            value: porcentaje,
                            message: "El valor máximo a ingresar solo puede ser de 100",
                          },
                          min: {
                            value: 0,
                            message: "El valor mínimo a ingresar solo puede ser de 0",
                          },
                          validate: {
                            porcentaje: (value) => {
                              const porcentajeTemp = getPorcentajeDisponibleForm();

                              if (value > porcentajeTemp) {
                                return `Solo esta dispobile el ${porcentajeTemp}%`;
                              }

                              return true;
                            },
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}

                  <div className='form-group col-7 '>
                    <SimpleContainer label='Sexo:' name='sexo'>
                      <DropDown
                        name='sexo'
                        options={[
                          { value: "M", label: "Masculino" },
                          { value: "F", label: "Femenino" },
                        ]}
                      />
                    </SimpleContainer>
                  </div>
                  {/* FIN */}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className='btn btn-atras-api' color='secondary' onClick={toggle}>
                Cerrar
              </button>

              <button
                className='btn btn-siguiente-api'
                color='primary'
                type='submit'
                onClick={methods.handleSubmit(onClickGuardar)}>
                Guardar
              </button>
            </Modal.Footer>
          </Modal>
        </form>
      </FormProvider>
    </div>
  );
};
